module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/link-arrow-light-320ed549e5b6f90d117cead5e7848a68.svg";